import { defineStore } from 'pinia'
export interface AppStore {
  locationId: string
  groupId?: string
  userId: string
  isAuthenticated?: boolean
}

export const useAppStore = defineStore('app', {
  state: () => ({
    locationId: '',
    groupId: '',
    userId: '',
    isAuthenticated: false,
    userEmail: '',
    token: '',
    appType: 'STANDALONE',
    companyId: '',
    timezone: '',
    redirectUrl: '',
    languagePreferenceBuilder: '',
    requestRetryCount: 0,
    locationPermissions: {
      membershipEnabled: false,
      affiliateManagerEnabled: false,
      communitiesEnabled: false,
      gokollabEnabled: false
    },
    branding: {
      brandColor2: null,
      brandColor1: null,
      portalBannerText: null,
      portalDescription: null,
      portalBackgroundImage: null,
      portalIcon: null,
      favicon: null,
      copyRight: null,
      supportEmail: null,
    },
    profileDetails: {
      email: '',
      fullName: '',
      bio: '',
      avatar: '',
      role: '',
      timeZone: '',
      location: '',
      slug: '',
      socials: {
        phoneNumber: '',
        facebook: '',
        twitter: '',
        instagram: '',
        linkedin: '',
        youtube: '',
        email: '',
      },
    },
    calendar: {
      isCalendarView: true,
      currentDate: new Date(),
    },
  }),
  actions: {
    updateRequestRetryCount(count: number) {
      this.requestRetryCount = count
    },
    initialize(payload: any) {
      this.locationId = payload.locationId
      this.userId = payload.userId
      this.userEmail = payload.userEmail
      this.token = payload.token
      this.companyId = payload.companyId
      this.timezone = payload.timezone
      this.appType = payload.appType
      this.locationId = payload.locationId
      this.userId = payload.userId
      this.branding = {
        brandColor1: null,
        brandColor2: null,
        portalBannerText: null,
        portalIcon: null,
        portalDescription: null,
        portalBackgroundImage: null,
        favicon: null,
        copyRight: null,
        supportEmail: null,
      }
    },
    refreshToken(newToken: string) {
      this.token = newToken
    },

    setBrandingValue(value: any) {
      this.branding.portalBannerText = value.portalBannerText
      this.branding.portalDescription = value.portalDescription
      this.branding.brandColor1 = value.brandColor1
      this.branding.brandColor2 = value.brandColor2
      this.branding.portalIcon = value.portalIcon
      this.branding.favicon = value.favicon
      this.branding.copyRight = value.copyRight
      this.branding.supportEmail = value.supportEmail
      this.locationId = value.locationId
      this.branding.portalBackgroundImage = value.portalBackgroundImage
    },

    setProfileDetails(value: any) {
      this.userId = value.contactId
      this.profileDetails.email = value.email
      this.profileDetails.fullName = value.fullName
      this.profileDetails.bio = value?.bio
      this.profileDetails.avatar = value?.avatar
      this.profileDetails.timeZone = value?.timeZone
      this.profileDetails.location = value?.location
      this.profileDetails.slug = value?.slug
      this.profileDetails.socials.phoneNumber = value?.socials?.phoneNumber
      this.profileDetails.socials.facebook = value?.socials?.facebook
      this.profileDetails.socials.twitter = value?.socials?.twitter
      this.profileDetails.socials.instagram = value?.socials?.instagram
      this.profileDetails.socials.youtube = value?.socials?.youtube
      this.profileDetails.socials.linkedin = value?.socials?.linkedin
      this.profileDetails.socials.email = value?.socials?.email
    },
    setPermissions(payload) {
      this.locationPermissions.membershipEnabled =
        payload.locationPermissions?.membershipEnabled
      this.locationPermissions.affiliateManagerEnabled =
        payload.locationPermissions?.affiliateManagerEnabled
      this.locationPermissions.communitiesEnabled =
        payload.locationPermissions?.communitiesEnabled
      this.locationPermissions.gokollabEnabled = 
        payload.locationPermissions?.gokollabEnabled
    },

    setLanguagePreference(value: string) {
      this.languagePreferenceBuilder = value
    },

    setRedirectUrl(redirectUrl: string) {
      this.redirectUrl = redirectUrl
    },
    setAuthenticated(value: boolean) {
      this.isAuthenticated = value
    },
    setLocationId(locationId: string) {
      this.locationId = locationId
    },
    setGroupId(groupId: string) {
      this.groupId = groupId
    },
    setUserId(userId: string) {
      this.userId = userId
    },
    setIsCalendarView(isCalendarView: boolean) {
      this.calendar.isCalendarView = isCalendarView
    },
  },
})
